import { NgModule } from '@angular/core';
import { CacheServiceModule, UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration } from '../interfaces/uzurv-rest-configuration';
import { UzurvRestApiModule } from './uzurv-rest-api.module';

export const uzurvApiTestConfiguration: UzurvRestConfiguration = {
  claraApiUrl: 'http://localhost:8081/v1.1.4/',
  dotsApiUrl: 'http://localhost:8082/v1.0.0/',
  reportingApiUrl: 'http://localhost:8082/',
  googleMapsApiKey: 'AIzaSyC6RJsWCto-9VCqcLeljDMN9fONylc_Sv4',
  httpDebugMode: false
};

@NgModule({
  imports: [UzurvRestApiModule.forRoot(uzurvApiTestConfiguration), CacheServiceModule, UzurvPipesModule, UzurvDirectivesModule],
  providers: [
    {
      provide: UZURV_REST_CONFIGURATION,
      useValue: uzurvApiTestConfiguration
    }
  ]
})
export class UzurvServicesTestingModule {}
